import styles from "../../styles/radio.module.scss";

import classNames from "classnames/bind";

export const Radio = ({
  id,
  checked,
  onChange,
  onClick,
  family,
  value,
  disabled,
  className,
  children,
  text,
  readOnly,
}) => {
  const cx = classNames.bind(styles);
  return (
    <div
      className={cx({
        radioContainer: true,
        disabled: disabled,
        [className]: className,
        readOnly: readOnly,
      })}
    >
      <label htmlFor={id}>
        <input
          id={id}
          type="radio"
          family={family}
          value={value}
          checked={checked === value}
          onChange={onChange}
          onClick={onClick}
          readOnly={readOnly}
        />
        <div className={styles.radio}></div>
        {(children || text) && <span>{children || text}</span>}
      </label>
    </div>
  );
};
